import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      REFER_A_FRIEND: "Verv en venn",
      READ_MORE_ABOUT_THE_CAMPAIGN: "Les mer om kampanjen",
    },
    se: {
      REFER_A_FRIEND: "Värva en vän",
      READ_MORE_ABOUT_THE_CAMPAIGN: "Läs mer om kampanjen",
    },
    dk: {
      REFER_A_FRIEND: "Anbefal til en ven",
      READ_MORE_ABOUT_THE_CAMPAIGN: "Læs mere om kampagnen",
    },
  } as const
)[language];
